import React from 'react';
import { OrderMaster } from '../../../../constants/types';
import TextWinds from '../../../../components/common/TextWinds';
import Buttons from '../../../../components/common/Buttons';
import { numberWithCommas } from '../../../../api/utils/format/numbers';
import { formatDate } from '../../../../api/utils/format/dates';
import { useNavigate } from 'react-router-dom';
import {
  getItemName,
  handleCopyClipBoard,
} from '../../../../api/utils/util-func';
import CompleteRow from './CompleteRow';
import IconCopy from '../../../lms/studentmgmt/popup/IconCopy';
import { getLatestTransaction } from '../../../../api/utils/order-item-transaction';

interface DepositProps {
  data: OrderMaster;
}

/** 무통장 입금(가상계좌) 완료 페이지 */
const Deposit = ({ data }: DepositProps) => {
  const navigate = useNavigate();
  const onClickHandler = (path: string) => {
    navigate(path);
  };

  const copyHandler = (text: string) => {
    handleCopyClipBoard(text).then(() => {
      alert('입금 계좌번호가 복사되었습니다.');
    });
  };

  const latestTransaction = getLatestTransaction(data.transactions);

  return (
    <div className="mx-auto flex w-full max-w-[480px] flex-col items-center gap-4 bg-white p-5">
      <TextWinds type="title_h2">주문 접수</TextWinds>

      <div className="relative h-[100px] w-[100px] shrink-0">
        <img
          className="absolute left-[16px] top-[9px]"
          width="67"
          height="81"
          src={process.env.PUBLIC_URL + '/images/payment_complete.png'}
        />
      </div>

      <TextWinds type="content_body2" color="purple5">
        주문이 정상적으로 접수되었습니다.
        <br />
        입금이 완료되면 주문이 완료됩니다.
      </TextWinds>

      <CompleteRow>
        <TextWinds type="sub_title01">입금계좌</TextWinds>
        <div
          className="group flex cursor-pointer items-center gap-2 text-purple5"
          onClick={() =>
            copyHandler(
              `${latestTransaction.bankName} ${latestTransaction.accountNo}`,
            )
          }
        >
          <TextWinds type="content" className="group-hover:text-purple5">
            {latestTransaction.bankName} {latestTransaction.accountNo}
          </TextWinds>
          <div className="animate-bounce">
            <IconCopy />
          </div>
        </div>
      </CompleteRow>

      <CompleteRow>
        <TextWinds type="sub_title01">예금주</TextWinds>
        <TextWinds type="content">{latestTransaction.depositName}</TextWinds>
      </CompleteRow>

      <CompleteRow>
        <TextWinds type="sub_title01">입금기한</TextWinds>
        <TextWinds type="content">
          {formatDate(latestTransaction.expiryDate)}
        </TextWinds>
      </CompleteRow>

      <CompleteRow>
        <TextWinds type="sub_title01">입금금액</TextWinds>
        <TextWinds type="content">
          {numberWithCommas(latestTransaction.balance_added)} 원
        </TextWinds>
      </CompleteRow>

      <div className="h-0 shrink-0 self-stretch border-[1px] border-solid border-[#adb5bd]" />

      <CompleteRow>
        <TextWinds className="w-[100px]" type="content_rel">
          상품명
        </TextWinds>
        <TextWinds type="content_rel">
          {getItemName(data.template.order_items)}
        </TextWinds>
      </CompleteRow>

      <CompleteRow>
        <TextWinds className="w-[100px]" type="content_rel">
          주문번호
        </TextWinds>
        <TextWinds type="content_rel">
          {latestTransaction.order_master_id}
        </TextWinds>
      </CompleteRow>

      <CompleteRow>
        <TextWinds className="w-[100px]" type="content_rel">
          주문자 성함
        </TextWinds>
        <TextWinds type="content_rel">{data.user.name}</TextWinds>
      </CompleteRow>
      <CompleteRow>
        <TextWinds className="w-[100px]" type="content_rel">
          주문일자
        </TextWinds>
        <TextWinds type="content_rel">
          {formatDate(latestTransaction.created_at)}
        </TextWinds>
      </CompleteRow>
      <CompleteRow>
        <TextWinds className="w-[100px]" type="content_rel">
          배송지
        </TextWinds>
        <TextWinds type="content_rel" className="text-right">
          {data.address_1} {data.address_2}
        </TextWinds>
      </CompleteRow>

      <CompleteRow className="gap-3">
        <Buttons
          type="filled"
          color="purple5"
          onClick={() => onClickHandler('/mypage/purchase')}
        >
          <TextWinds type="button" color="white">
            결제 상세 페이지 이동
          </TextWinds>
        </Buttons>
        <Buttons
          type="outlined"
          color="purple5"
          onClick={() => onClickHandler('/shop')}
        >
          <TextWinds type="button" color="purple5">
            SHOP 메인으로 이동
          </TextWinds>
        </Buttons>
      </CompleteRow>
    </div>
  );
};

export default Deposit;
